import { Background as PageBackground} from "./background.styles";


export const Background = () => {
  return <PageBackground />;
};
